import { combineReducers } from 'redux';

import {
  customerSliceReducer,
  CustomerState,
  initialCustomerState,
} from './customer';

import {
  cancellationReducer,
  CancellationState,
  initialCancellationState,
} from './cancellation';

import {
  reactivationReducer,
  ReactivationState,
  initialReactivationState,
} from './reactivation';

import { pauseReducer, PauseState, initialPauseState } from './pause';

import {
  prescriptionReducer,
  PrescriptionState,
  initialPrescriptionState,
} from './prescription';

import {
  subscriptionReducer,
  SubscriptionState,
  initialSubscriptionState,
} from './subscription';

export * from './customer';
export * from './cancellation';
export * from './reactivation';
export * from './pause';
export * from './prescription';
export * from './subscription';

export type CustomersState = {
  customer: CustomerState;
  cancellation: CancellationState;
  reactivation: ReactivationState;
  pause: PauseState;
  prescription: PrescriptionState;
  subscription: SubscriptionState;
};

export const initialCustomersState: CustomersState = {
  customer: initialCustomerState,
  cancellation: initialCancellationState,
  reactivation: initialReactivationState,
  pause: initialPauseState,
  prescription: initialPrescriptionState,
  subscription: initialSubscriptionState,
};

export const customersReducers = combineReducers({
  customer: customerSliceReducer,
  cancellation: cancellationReducer,
  reactivation: reactivationReducer,
  pause: pauseReducer,
  prescription: prescriptionReducer,
  subscription: subscriptionReducer,
});
